import { render, staticRenderFns } from "./ModificaDatiContratto.vue?vue&type=template&id=3a88ba0a&scoped=true&"
import script from "./ModificaDatiContratto.vue?vue&type=script&lang=js&"
export * from "./ModificaDatiContratto.vue?vue&type=script&lang=js&"
import style0 from "./ModificaDatiContratto.vue?vue&type=style&index=0&id=3a88ba0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a88ba0a",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QSelect,QIcon,QPopupProxy,QDate,QBtn});qInstall(component, 'directives', {ClosePopup});
